import { connect } from "react-redux";
import { Selectors } from "@/store/saloonProfile/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import Aside from "./";

const mSp = (state) => ({
  saloonId: Selectors.getId(state),
  interior: Selectors.getInteriorPhotos(state),
  interiorPhotoDefaultAltText: Selectors.getInteriorPhotoDefaultAltText(state),
  isOwner: Selectors.isOwner(state),
  isPremium: Selectors.isPremium(state),
  weekSchedule: Selectors.getWeekSchedule(state),
  masters: Selectors.getMasters(state),
  coords: Selectors.getCoords(state),
  locale: UserSelectors.getLocale(state),
});

export default connect(mSp)(Aside);
